<script setup lang="ts">
import Typography from '@components/Typography.vue';
import { useStreetDistrict } from '@composables/useStreetDistrict.ts';
import type { CommonAddress } from '@models/interfaces/commonAddress';

const props = defineProps<{ address: CommonAddress }>();

const { formattedStreetDistrict } = useStreetDistrict(props.address);
</script>

<template>
  <Typography
    as="span"
    variant="body-bold"
    class="offer-card__title"
  >
    {{ formattedStreetDistrict }}
  </Typography>
</template>
